'use client'
import Script from 'next/script'
import { INTERCOM_WORKSPACE_ID } from '@/lib/constants'
import { isDevelopment } from '@/lib/general-helpers'

declare global {
	interface Window {
		intercomSettings: {
			app_id: string
		}
		// biome-ignore lint/suspicious/noExplicitAny: Intercom's API requires flexible arguments
		Intercom: (...args: any[]) => void
	}
}

export const IntercomScript = () => {
	const workspaceId = INTERCOM_WORKSPACE_ID

	if (!workspaceId || isDevelopment()) {
		return null
	}

	return (
		// biome-ignore lint/correctness/useUniqueElementIds: static ID for third-party script container
		<Script
			id="intercom-widget"
			strategy="afterInteractive"
			src={`https://widget.intercom.io/widget/${workspaceId}`}
			onLoad={() => {
				window.intercomSettings = { app_id: workspaceId }

				const w = window
				const ic = w.Intercom
				if (typeof ic === 'function') {
					ic('reattach_activator')
					ic('update', w.intercomSettings)
				} else {
					const i = (...args: unknown[]) => {
						i.c(args)
					}
					// biome-ignore lint/suspicious/noExplicitAny: Intercom queue requires flexible structure
					i.q = [] as any[]
					// biome-ignore lint/suspicious/noExplicitAny: Intercom callback requires flexible arguments
					i.c = (args: any) => {
						i.q.push(args)
					}
					w.Intercom = i
				}
			}}
		/>
	)
}
